import { SiteIdOverrideConfig } from "stores/wizard/config";

const defaultOffsetDates = {
  start: 1,
  end: 2,
};

export const siteId4: SiteIdOverrideConfig = {
  global: {
    packageWith3PP: true,
  },
  package: {
    heading: {
      visibleLobSubtitle: false,
    },
    date: {
      defaultOffsetDates,
    },
  },
  cruise: {
    heading: {
      lobSubtitleBreakPoint: "on",
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-888-444-1695",
    },
  },
  thirdPartyPackage: {
    showGroupLink: true,
  },
};
